module.exports = __webpack_public_path__ + "img/logo-mustach-98x56.9290547b.png";